import React from 'react';
import { map } from 'lodash';
import MyOrdersListItem from './MyOrdersListItem';

const MyOrdersList = ({ bets }) => map(bets, (bet) => <MyOrdersListItem bet={bet} />);

export default MyOrdersList;
